"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canUseSupabase = void 0;
/**
 * Supabase is a Premium-tier integration.
 *
 * Same shape every other paid integration uses (see `canUseWooCommerce` and
 * `canUseCustomObjects` in the frontend account store): the plan tier grants
 * it, and `payment.features.supabase` is the per-account override we set by
 * hand for accounts that negotiated access outside their plan.
 *
 * Trials count as premium, exactly as `accountStore.accountTier` treats them -
 * otherwise a trialling account could not evaluate the integration before
 * deciding to pay for it.
 *
 * This lives in domain rather than only on the frontend store because the
 * Supabase webhook receiver has to apply the same rule. The ingest URL is
 * meant to be pasted into a customer's own Supabase project, so it outlives
 * any UI gate: an account that connected while entitled - or that simply got
 * the URL - would keep posting events forever if the check were frontend-only.
 */
const canUseSupabase = (account) => {
    var _a, _b, _c, _d;
    const tier = account.status === "trial" ? "premium" : (_b = (_a = account.payment) === null || _a === void 0 ? void 0 : _a.plan) === null || _b === void 0 ? void 0 : _b.tier;
    return Boolean(tier === "premium" || ((_d = (_c = account.payment) === null || _c === void 0 ? void 0 : _c.features) === null || _d === void 0 ? void 0 : _d.supabase));
};
exports.canUseSupabase = canUseSupabase;
//# sourceMappingURL=canUseSupabase.js.map